import axios from 'axios';
import { useRouter } from 'next/router';
import qs from 'qs';
import { useCallback } from 'react';
import { Image } from '@components/common/Image';
import { UiKitButton } from '@components/common/ui-kit-button';
import { ButtonGroup } from '@features/Unsubscribe/components/ButtonGroup';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardSteps } from '@features/Unsubscribe/types';
import { WIZARD_STEPS } from '../../сonstants';
import { useGetAppName } from 'src/utils/hooks';
import LockIcon from '../../../../../public/icons/lock-icon-gray.svg';
import styles from './KeepPremium.module.scss';
const FIRST_COLUMN = ['Personal Program', 'AR coach', 'Full access to programs', 'Challenges', 'Skin care guides', 'E-Book'];
const secondColumnContent = <LockIcon className={styles.lockIcon} />;
const thirdColumnContent = <Image className={styles.okIcon} src="ok-icon.webp" alt="ok-icon" width={24} height={24} />;
export const KeepPremium = (props: TpWizardSteps) => {
  const {
    defaultEventOptions,
    trackUnsubscribeEvent,
    trackUnsubscribeRequestError,
    trackUnsubscribeRequestSuccess
  } = useUnsubscribeAnalytics();
  const {
    wizard,
    featureFlags
  } = props;
  const {
    query
  } = useRouter();
  const app = useGetAppName();
  const cancelNextStep = featureFlags?.pause ? WIZARD_STEPS.GIFT_PREMIUM : WIZARD_STEPS.SAD;
  const handleNext = useCallback(async () => {
    const formData = {
      app: app,
      email: defaultEventOptions.email,
      user_id: defaultEventOptions.userId
    };
    const requestOptions = {
      endpoint: 'cancel_subscription',
      requestName: 'cancel_subscription',
      source: 'keep_premium_keep_subscription'
    };
    try {
      if (!featureFlags?.pause) {
        const response = await axios({
          method: 'post',
          url: `${process.env.NEXT_PUBLIC_API_MICROSERVICE_ENDPOINT}cancel_subscription`,
          data: qs.stringify(formData)
        });
        trackUnsubscribeRequestSuccess('cancel_subscription_cancel_succeeded', requestOptions, response.status);
      }
      trackUnsubscribeEvent('cancel_keep_premium_chosen', {
        variant: '1- keep subscription'
      });
      wizard.goToStep(WIZARD_STEPS.HAPPY);
    } catch (error) {
      trackUnsubscribeRequestError('cancel_subscription_cancel_failed', error, requestOptions);
      wizard.goToStep(WIZARD_STEPS.ERROR);
      console.log('error', error);
    }
  }, [defaultEventOptions.email, defaultEventOptions.userId, featureFlags?.pause, trackUnsubscribeEvent, trackUnsubscribeRequestError, trackUnsubscribeRequestSuccess, wizard, app]);
  const handleCancel = useCallback(async () => {
    const formData = {
      app: app,
      email: defaultEventOptions.email,
      user_id: defaultEventOptions.userId
    };
    const requestOptions = {
      endpoint: 'cancel_subscription',
      requestName: 'cancel_subscription',
      source: 'keep_premium_cancel_anyway'
    };
    try {
      if (!featureFlags?.pause) {
        const response = await axios({
          method: 'post',
          url: `${process.env.NEXT_PUBLIC_API_MICROSERVICE_ENDPOINT}cancel_subscription`,
          data: qs.stringify(formData)
        });
        trackUnsubscribeRequestSuccess('cancel_subscription_cancel_succeeded', requestOptions, response.status);
      }
      trackUnsubscribeEvent('cancel_keep_premium_chosen', {
        variant: '2-cancel'
      });
      wizard.goToStep(cancelNextStep);
    } catch (error) {
      trackUnsubscribeRequestError('cancel_subscription_cancel_failed', error, requestOptions);
      wizard.goToStep(WIZARD_STEPS.ERROR);
      console.log('error', error);
    }
  }, [cancelNextStep, defaultEventOptions.email, defaultEventOptions.userId, featureFlags?.pause, trackUnsubscribeEvent, trackUnsubscribeRequestError, trackUnsubscribeRequestSuccess, wizard, app]);
  return <Container className={styles.container} eventOnMounted="cancel_keep_premium_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="KeepPremium" data-sentry-source-file="index.tsx">
      <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">
        Keep Premium for <br />
        better results
      </Title>
      <p className={styles.subtitle}>
        Premium subscribers achieve <br /> anti-aging effect <b>4.5 times</b>{' '}
        faster
      </p>
      <table className={styles.table}>
        <thead className={styles.tableHead}>
          <tr className={styles.headRow}>
            <th></th>
            <td className={styles.free}>Free</td>
            <th className={styles.premium}>Premium</th>
          </tr>
        </thead>
        <tbody>
          {FIRST_COLUMN.map((data, index) => <tr key={index} className={styles.row}>
              <td className={styles.firstColumn}>{data}</td>
              <td className={styles.secondColumn}>{secondColumnContent}</td>
              <td className={styles.secondColumn}>{thirdColumnContent}</td>
            </tr>)}
        </tbody>
      </table>

      <ButtonGroup className={styles.buttonGroup} data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
        <UiKitButton color="pure" onClick={handleCancel} className={styles.button} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Cancel anyway
        </UiKitButton>
        <UiKitButton fullWidth onClick={handleNext} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Keep my subscription
        </UiKitButton>
      </ButtonGroup>
    </Container>;
};